import React from 'react';
import { RiDeleteBin2Line, RiCloseLine } from 'react-icons/ri';

interface BulkActionsBarProps {
  selectedCount: number;
  onBulkDelete?: () => void;
  onClearSelection?: () => void;
  loading?: boolean;
  /** Alias for loading (backward compat) */
  bulkLoading?: boolean;
  deleteLabel?: string;
  customActions?: React.ReactNode;
  className?: string;
}

const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  selectedCount,
  onBulkDelete,
  onClearSelection,
  loading = false,
  bulkLoading,
  deleteLabel = 'ลบที่เลือก',
  customActions,
  className = '',
}) => {
  // Support both loading and bulkLoading aliases
  const isLoading = bulkLoading !== undefined ? bulkLoading : loading;
  if (selectedCount === 0) return null;

  return (
    <div className={`mb-4 bg-primary-50 border border-primary-200/70 rounded-xl px-4 min-h-[44px] sm:min-h-[42px] py-2.5 flex flex-wrap items-center justify-between gap-2 shadow-sm ${className}`}>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 rounded bg-primary-600 flex items-center justify-center">
            <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </div>
          <span className="text-sm font-semibold text-primary-700" role="status" aria-live="polite" aria-atomic="true">
            เลือกแล้ว {selectedCount} รายการ
          </span>
        </div>
        {onClearSelection && (
          <button
            onClick={onClearSelection}
            className="text-xs text-primary-500 hover:text-primary-700 flex items-center gap-1 transition-colors"
          >
            <RiCloseLine className="w-3.5 h-3.5" />
            ยกเลิก
          </button>
        )}
      </div>
      <div className="flex items-center gap-2">
        {customActions}
        {onBulkDelete && (
          <button
            onClick={onBulkDelete}
            disabled={isLoading}
            className="inline-flex items-center gap-1.5 px-3 min-h-[44px] sm:min-h-[32px] py-1.5 bg-danger-600 text-white text-xs font-medium rounded-lg hover:bg-danger-700 focus:outline-none focus:ring-2 focus:ring-danger-500/30 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm"
          >
            {isLoading ? (
              <>
                <svg className="animate-spin w-3.5 h-3.5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                กำลังลบ...
              </>
            ) : (
              <>
                <RiDeleteBin2Line className="w-3.5 h-3.5" />
                {deleteLabel}
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default BulkActionsBar;
